import React from 'react'

// all tabs component
import AttributesTab from './Tabs/AttributesTab'
import BuyNowTab from './Tabs/BuyNowTab'
import FilesTab from './Tabs/FilesTab'
import GeneralTab from './Tabs/GeneralTab'
import RelatedProductsTab from './Tabs/RelatedProductsTab'
import SeoTab from './Tabs/SeoTab'
import TaxAndShippingTab from './Tabs/TaxAndShippingTab'
import Purchasability from './Tabs/Purchasability'
import VariationsTab from './Tabs/VariationsTab'

export default function PageLeftView(props) {
    // props
    const {
        pageActiveTab,
        formik,

        // GENERAL TAB
        productImages,
        getImagesToBeSaved,

        getDesc,

        categories,
        selectedCategories,
        setSelectedCategories,
        defaultCategories,
        categoriesToBeSaved,
        setCategoriesToBeSaved,
        errorInCategories,
        setErrorInCategories,

        ribbonColors,

        // ATTRIBUTES TAB
        brands,

        productAttributes,
        setSelectedProductsAttributes,
        selectedProductsAttributes,

        // VARIATIONS TAB
        productCombinations,
        setProductCombinations,
        productCombinationsImages,
        variantMainFields,

        disabledVariantList,
        setDisabledVariantList,

        handleVariantPageShow,

        // SEO TAB
        allowedMetaTitleLength,
        allowedMetaDescLength,
    } = props


    return (
        <React.Fragment>
            {/* listing tabs */}
            {
                (pageActiveTab === 'general_tab') ? (
                    <GeneralTab
                        productImages={productImages}
                        getImagesToBeSaved={getImagesToBeSaved}

                        formik={formik}

                        getDesc={getDesc}

                        categories={categories}
                        selectedCategories={selectedCategories}
                        setSelectedCategories={setSelectedCategories}
                        defaultCategories={defaultCategories}
                        setCategoriesToBeSaved={setCategoriesToBeSaved}
                        categoriesToBeSaved={categoriesToBeSaved}
                        errorInCategories={errorInCategories}
                        setErrorInCategories={setErrorInCategories}

                        ribbonColors={ribbonColors}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'attributes_tab') ? (
                    <AttributesTab
                        formik={formik}

                        brands={brands}

                        productAttributes={productAttributes}
                        setSelectedProductsAttributes={setSelectedProductsAttributes}
                        selectedProductsAttributes={selectedProductsAttributes}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'variations_tab') ? (
                    <VariationsTab
                        formik={formik}

                        productCombinations={productCombinations}
                        setProductCombinations={setProductCombinations}
                        productCombinationsImages={productCombinationsImages}
                        variantMainFields={variantMainFields}

                        disabledVariantList={disabledVariantList}
                        setDisabledVariantList={setDisabledVariantList}

                        handleVariantPageShow={handleVariantPageShow}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'seo_tab') ? (
                    <SeoTab
                        formik={formik}

                        allowedMetaTitleLength={allowedMetaTitleLength}
                        allowedMetaDescLength={allowedMetaDescLength}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'files_tab') ? (
                    <FilesTab
                        formik={formik}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'tax_and_shipping_tab') ? (
                    <TaxAndShippingTab
                        formik={formik}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'purchasability_tab') ? (
                    <Purchasability
                        formik={formik}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'related_products_tab') ? (
                    <RelatedProductsTab
                        formik={formik}
                    />
                ) : null
            }
            {
                (pageActiveTab === 'buy_now_tab') ? (
                    <BuyNowTab
                        formik={formik}
                    />
                ) : null
            }
        </React.Fragment>
    )
}
